module.exports = __webpack_public_path__ + "static/media/puppy.8650793e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/puppy.svg
// module id = 478
// module chunks = 0